"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implements a no-cache strategy.
 *
 * @author Fabien Potencier <fabien@symfony.com>
 */
class TwingCacheNull {
    constructor() {
        this.TwingCacheInterfaceImpl = this;
    }
    generateKey(name, className) {
        return '';
    }
    write(key, content) {
    }
    load(key) {
        return () => {
            return {};
        };
    }
    getTimestamp(key) {
        return 0;
    }
}
exports.TwingCacheNull = TwingCacheNull;
